import moment from 'moment'

export const customerComplaintAreaOwner = {
  id: '',
  distributedToInternal: moment().format('YYYY-MM-DD'),
  receivedDate: moment().format('YYYY-MM-DD'),
  reportedDate: moment().format('YYYY-MM-DD'),
  customerId: '',
  customerName: '',
  address: '',
  pic: '',
  email: '',
  brandId: '',
  brandName: '',
  productId: '',
  productName: '',
  phone: '',
  plantId: '',
  plantName: '',
  packagingId: '',
  packagingName: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
  blDate: moment().format('YYYY-MM-DD'),
  dispatchDate : moment().format('YYYY-MM-DD'),
  dischargePort : '',
  countryId: '',
  countryName: '',
  containerNo: '',
  modelOfDeliveryId: '',
  modelOfDeliveryName: '',
  conformanceTypeId: '',
  conformanceTypeName: '',
  complaintMediaId: '',
  complaintMediaName: '',
  enclosedId: '',
  enclosedName: '',
  description: '',
  ccSalesAttachment: '',
  ccAreaOwnerAttachment: '',
  createdBy: '',
  updatedBy: '',
  createdAt: moment().format('YYYY-MM-DD'),
  updatedAt: moment().format('YYYY-MM-DD'),
}

export const correctiveExternal = {
  id: '',
  customerComplaintId: '',
  investigationDetail: '',
  corrective: '',
  preventive: '',
}

export const correctivePreventiveInternal = {
  id: '',
  customerComplaintId: '',
  rootCauseType: '',
  rootCauseRemark: '',
  actionType: '',
  actionRemark: '',
  workDescription: '',
  evidence: '',
  picId: '',
  picName: '',
  picEmail: '',
  targetDate: moment().format('YYYY-MM-DD'),
}

export const customerComplaintInvestigationDetail = {
  id: '',
  customerComplaintId: '',
  question: '',
  memberId: '',
  responder: '',
  email: '',
  attachment: '',
  answeredAt: '',
}

export const customerComplaintDetail = {
  customerComplaintId: '',
  po: '',
  so: '',
  batch: '',
  qty: 0,
}